(() => {
  const normalize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s&-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const matches = (card, query, category) => {
    const text = normalize(`${card.dataset.title} ${card.dataset.summary} ${card.dataset.categories}`);
    return (!query || text.includes(normalize(query)))
      && (!category || card.dataset.categories.split(' ').includes(category));
  };

  document.querySelectorAll('[data-certnz-blog-index]').forEach((root) => {
    const form = root.querySelector('[data-certnz-blog-search]');
    const input = root.querySelector('[data-certnz-blog-search-input]');
    const clearButton = root.querySelector('[data-certnz-blog-clear]');
    const resetButton = root.querySelector('[data-certnz-blog-reset]');
    const filters = [...root.querySelectorAll('[data-certnz-blog-filter]')];
    const cards = [...root.querySelectorAll('[data-certnz-blog-card]')];
    const results = root.querySelector('[data-certnz-blog-results][aria-live="polite"]');
    const empty = root.querySelector('[data-certnz-blog-empty]');

    if (!form || !input || !clearButton || !results || !empty || !cards.length) return;

    let state = { query: '', category: '' };
    let initialized = false;
    const canFilterInPlace = !window.location.pathname.includes('/tagged/');

    const labels = {
      singular: results.dataset.singular || 'guide',
      plural: results.dataset.plural || 'guides',
    };

    const readUrlState = () => {
      const params = new URLSearchParams(window.location.search);
      const activeFilter = filters.find((filter) => filter.classList.contains('is-active'));
      const category = params.get('category') || (activeFilter?.dataset.category === 'all' ? '' : activeFilter?.dataset.category) || '';
      return { query: params.get('q') || '', category };
    };

    const writeUrlState = () => {
      const url = new URL(window.location.href);
      if (state.query) url.searchParams.set('q', state.query);
      else url.searchParams.delete('q');
      if (state.category) url.searchParams.set('category', state.category);
      else url.searchParams.delete('category');
      history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const render = ({ updateUrl = true } = {}) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const visible = matches(card, state.query, state.category);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      filters.forEach((filter) => {
        const filterCategory = filter.dataset.category === 'all' ? '' : filter.dataset.category;
        const active = filterCategory === state.category;
        filter.classList.toggle('is-active', active);
        if (active) filter.setAttribute('aria-current', 'page');
        else filter.removeAttribute('aria-current');
      });

      const label = visibleCount === 1 ? labels.singular : labels.plural;
      results.textContent = `${visibleCount} ${label} on this page`;
      empty.hidden = visibleCount > 0;
      clearButton.hidden = !state.query;
      input.value = state.query;

      if (updateUrl) writeUrlState();
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      state.query = input.value.trim();
      render();
    });

    input.addEventListener('input', () => {
      state.query = input.value.trim();
      render();
    });

    clearButton.addEventListener('click', () => {
      state.query = '';
      render();
      input.focus();
    });

    resetButton?.addEventListener('click', () => {
      state = { query: '', category: '' };
      render();
      input.focus();
    });

    filters.forEach((filter) => {
      filter.addEventListener('click', (event) => {
        if (!initialized || !canFilterInPlace) return;
        event.preventDefault();
        state.category = filter.dataset.category === 'all' ? '' : filter.dataset.category;
        render();
      });
    });

    window.addEventListener('popstate', () => {
      state = readUrlState();
      render({ updateUrl: false });
    });

    state = readUrlState();
    initialized = true;
    root.dataset.enhanced = 'true';
    render({ updateUrl: false });
  });
})();
